import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '@src/app/app-routing.module';
import { AppComponent } from '@src/app/app.component';
import { OrgaddComponent } from '@src/app/components/org/orgadd/orgadd.component';
import { PersonComponent } from '@src/app/components/person/person/person.component';
import { PersonimageComponent } from '@src/app/components/person/personimage/personimage.component';
import { FooterComponent } from '@src/app/components/footer/footer.component';
import { OrgviewComponent } from '@src/app/components/org/orgview/orgview.component';
import { PersonorglistComponent } from '@src/app/components/person/personorglist/personorglist.component';
import { OrgmemberlistComponent } from '@src/app/components/org/orgmemberlist/orgmemberlist.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PersonmodalComponent } from '@src/app/components/person/personmodal/personmodal.component';
import { OrgeditComponent } from '@src/app/components/org/orgedit/orgedit.component';
import { BaserouteComponent } from '@src/app/components/baseroute/baseroute.component';
import { LoginComponent } from '@src/app/components/login/login.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmComponent } from '@src/app/components/confirm/confirm.component';
import { ForgotComponent } from '@src/app/components/forgot/forgot.component';
import { OrgprojectaddComponent } from '@src/app/components/org/orgprojectadd/orgprojectadd.component';
import { OrgprojectlistComponent } from '@src/app/components/org/orgprojectlist/orgprojectlist.component';
import { OrgprojecteditComponent } from '@src/app/components/org/orgprojectedit/orgprojectedit.component';
import { PeopleComponent } from '@src/app/components/pages/people/people.component';
import { PlanningComponent } from '@src/app/components/pages/planning/planning.component';
import { TopNavComponent } from '@src/app/components/top-nav/top-nav.component';
import { UseraccountComponent } from './components/pages/useraccount/useraccount.component';
import { OrgaccountComponent } from './components/pages/orgaccount/orgaccount.component';
import { TimereportComponent } from './components/pages/timereport/timereport.component';
import { TimetrackingpanelComponent } from './components/timetrackingpanel/timetrackingpanel.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OrglogoComponent } from './components/orglogo/orglogo.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PortalComponent } from './components/pages/portal/portal/portal.component';
import { ProjectslistComponent } from './components/pages/portal/projectslist/projectslist.component';
import { CustomerControlComponent } from './components/pages/customers/customer-control/customer-control.component';
import { CustomersComponent } from './components/pages/customers/customers/customers.component';
import { AdhocComponent } from './components/pages/adhoc/adhoc.component';
import { OrgprojectmemberlistComponent } from './components/org/orgprojectmemberlist/orgprojectmemberlist.component';
import { OrgprojectpendingjoinerlistComponent } from './components/org/orgprojectpendingjoinerlist/orgprojectpendingjoinerlist.component';
import { ProjectportalComponent } from './components/pages/portal/projectportal/projectportal.component';
import { ProjectstageComponent } from './components/pages/portal/projectstage/projectstage.component';
import { ProjecttaskComponent } from './components/pages/portal/projecttask/projecttask.component';
import { PersonnameComponent } from './components/person/personname/personname.component';
import { CustomeruserlistComponent } from './components/pages/customers/customeruserlist/customeruserlist.component';
import { CustomerprojectlistComponent } from './components/pages/customers/customerprojectlist/customerprojectlist.component';
import { CustomerusercreateComponent } from './components/pages/customers/customerusercreate/customerusercreate.component';
import { NotificationComponent } from './components/top-nav/notification/notification.component';
import { CustomerportalControlComponent } from './components/customerportal/customerportal-control/customerportal-control.component';
import { CustomernameComponent } from './components/org/customername/customername.component';
//import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NotificationPushComponent } from './components/top-nav/notification-push/notification-push.component';
import { ProjectoverviewComponent } from './components/pages/portal/projectoverview/projectoverview.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomerlogoComponent } from './components/customerlogo/customerlogo.component';
import { TasknameComponent } from './components/utilities/taskname/taskname.component';
import { ProjecttemplatecreateComponent } from './components/org/orgprojectlist/projecttemplatecreate/projecttemplatecreate.component';
import { ProjecttemplatelistComponent } from './components/org/orgprojectlist/projecttemplatelist/projecttemplatelist.component';
import { OrgtemplatelistComponent } from './components/pages/orgaccount/orgtemplatelist/orgtemplatelist.component';
import { DynamicstyleComponent } from './helpers/dynamicstyle/dynamicstyle.component';
import { OrgstyleComponent } from './components/pages/orgaccount/orgstyle/orgstyle.component';
import { AssigntemplaterolesComponent } from './components/org/orgprojectlist/assigntemplateroles/assigntemplateroles.component';
import { FileuploadComponent } from './components/fileupload/fileupload.component';
import { FilelistComponent } from './components/filelist/filelist.component';
import { CustomerpageComponent } from './components/pages/customers/customerpage/customerpage.component';
import { CustomerusereditComponent } from './components/pages/customers/customeruseredit/customeruseredit.component';
import { OrguseraddComponent } from './components/org/orguseradd/orguseradd.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { CustomercreateComponent } from './components/pages/customers/customer-control/customercreate/customercreate.component';
import { FooterMobileNavComponent } from './components/footer/footer-mobile-nav/footer-mobile-nav.component'
import { QuillModule } from 'ngx-quill';
import { NotificationlistComponent } from './components/footer/notificationlist/notificationlist.component';
import { NotificationitemComponent } from './components/footer/notificationitem/notificationitem.component';
import { FooterprojectlistComponent } from './components/footer/footerprojectlist/footerprojectlist.component';
import { TermsofuseComponent } from './termsofuse/termsofuse.component';
import { ShortdateComponent } from './helpers/shortdate/shortdate.component';
import { ProjectnotificationComponent } from './components/pages/portal/projectnotification/projectnotification.component';
import { RefreshauthComponent } from './components/pages/useraccount/refreshauth/refreshauth.component';
import { ProjectuserviewComponent } from './components/pages/portal/projectuserview/projectuserview.component';
import { ProjectnameComponent } from './components/utilities/projectname/projectname.component';
import { OrgnotificationsettingComponent } from './components/pages/orgaccount/orgnotificationsetting/orgnotificationsetting.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { BrandComponent } from './components/top-nav/brand/brand.component';
import { AddtokenInterceptor } from './helpers/addtoken.interceptor';
import { OrglogomenuComponent } from './components/top-nav/brand/orglogomenu/orglogomenu.component';
import { AdminComponent } from './components/pages/admin/admin.component';
import { HighlightDirective } from './helpers/highlight.directive';
import { FilterPipe } from './helpers/filter.pipe';
import { TransPipe } from './helpers/trans/trans.pipe';
import { TagfilterComponent } from './components/utilities/tagfilter/tagfilter.component';
import { TagaddremoveComponent } from './components/utilities/tagaddremove/tagaddremove.component';
import { TagadminComponent } from './components/utilities/tagadmin/tagadmin.component';
import { TableModule } from 'ngx-easy-table';
import { UniqueloginchartComponent } from './components/pages/admin/uniqueloginchart/uniqueloginchart.component';
import { ProjectvisibilitytoggleComponent } from './components/pages/portal/projectvisibilitytoggle/projectvisibilitytoggle.component';
import { ProjectdeleteComponent } from './components/pages/portal/projectdelete/projectdelete.component';
import { ProjectassignComponent } from './components/pages/portal/projectassign/projectassign.component';
import { ProjectimeshiftComponent } from './components/pages/portal/projectimeshift/projectimeshift.component';
import { ProjectprogressComponent } from './components/pages/portal/projectprogress/projectprogress.component';
import { UniquelogincounterComponent } from './components/pages/admin/uniquelogincounter/uniquelogincounter.component';
import { ProjectwizardComponent } from './components/pages/portal/projectwizard/projectwizard.component';
import { ProjectsettingsComponent } from './components/pages/portal/projectsettings/projectsettings.component';
import { LoadconfirmComponent } from './components/utilities/loadconfirm/loadconfirm.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard.component';
import { TasktrackerchartComponent } from './components/pages/dashboard/tasktrackerchart/tasktrackerchart.component';
import { DurationchartComponent } from './components/pages/dashboard/durationchart/durationchart.component';
import { StatuschartComponent } from './components/pages/dashboard/statuschart/statuschart.component';
import { CompactprojectlistComponent } from './components/pages/dashboard/compactprojectlist/compactprojectlist.component';
import { DurationselectComponent } from './components/pages/dashboard/durationselect/durationselect.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CustomerwelcomeComponent } from './components/customerportal/customerwelcome/customerwelcome.component';
import { CustomerwelcomeeditComponent } from './components/pages/orgaccount/customerwelcomeedit/customerwelcomeedit.component';
import { CustomertasklistComponent } from './components/customerportal/customertasklist/customertasklist.component';
import { ProjectcardComponent } from './components/pages/portal/projectcard/projectcard.component';
import { ErrorHandler } from '@angular/core';
import { SupportComponent } from './components/pages/support/support.component';
import { CustomerdealComponent } from './components/pages/customers/customerdeal/customerdeal.component';
import { CustomerdeallistComponent } from './components/pages/customers/customerdeallist/customerdeallist.component';
import { IntegrationsettingsComponent } from './components/pages/orgaccount/integrationsettings/integrationsettings.component';
import { ChartComponent } from './components/pages/planning/chart/chart.component';
import { OrgswitcherComponent } from './components/top-nav/orgswitcher/orgswitcher.component';
import { OrgsettingsComponent } from "./components/org/orgsettings/orgsettings.component";
import { UsersettingsComponent } from "./components/pages/useraccount/usersettings/usersettings.component";
import { RefreshsessionComponent } from './helpers/refreshsession/refreshsession.component';
import { CustomerportalLightComponent } from './components/pages/customerportal-light/customerportal-light.component';
import { NgOptimizedImage } from '@angular/common'
import { CplDownloadComponent } from './components/pages/customerportal-light/cpl-download/cpl-download.component';

import { AppErrorHandler } from './errorhandler';
import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { CustomerCardComponent } from './components/pages/customers/customer-control/customer-card/customer-card.component';
import { TaskeditmodalComponent } from './components/pages/portal/taskeditmodal/taskeditmodal.component';
import { CplSubmitComponent } from './components/pages/customerportal-light/cpl-submit/cpl-submit.component';
import { CplEventComponent } from './components/pages/customerportal-light/cpl-event/cpl-event.component';
import { CplTaskComponent } from './components/pages/customerportal-light/cpl-task/cpl-task.component';
import { CplListComponent } from './components/pages/customerportal-light/cpl-list/cpl-list.component';
import { ProjectautomationComponent } from './components/pages/portal/projectautomation/projectautomation.component';
import { AutomationactionComponent } from './components/pages/portal/projectautomation/automationaction/automationaction.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OrgautomationsComponent } from './components/pages/orgaccount/orgautomations/orgautomations.component';
import { AutomationFieldComponent } from "./components/pages/portal/projectautomation/automationfield/automationfield.component";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { CalendarComponent } from './components/pages/calendar/calendar.component';

import { ImageuploadComponent } from './components/imageupload/imageupload.component';
import { ImageUploadModule } from './components/image-upload/image-upload.module';
import { OrgnotificationlistComponent } from './components/pages/orgaccount/orgnotificationlist/orgnotificationlist.component';
import { AlertboxComponent } from './helpers/alertbox/alertbox.component';
import { FormRendererComponent } from './components/forms/renderer/form-renderer.component';
import { NotificationAutomationComponent } from './components/pages/notification-automation/notification-automation.component';
import { EngagementGaugeComponent } from './components/pages/portal/engagement-gauge/engagement-gauge.component';
import { ProjectdashComponent } from './components/pages/portal/projectdash/projectdash.component';

//...
// Bugfender.init({
//   appKey: 'WaCKIN78smsB5eKvTKQvP1xHKT5U9d6n',
//   // overrideConsoleMethods: true,
//   printToConsole: false,
//   registerErrorHandler: true,
//   // logBrowserEvents: true,
//   // logUIEvents: true,
//   version: '1.2.8',
//   // build: '',
// });

@NgModule({
  declarations: [
    AppComponent,
    ProjectcardComponent,
    OrgaddComponent,
    PersonComponent,
    FooterComponent,
    OrgviewComponent,
    PersonorglistComponent,
    OrgmemberlistComponent,
    PersonmodalComponent,
    OrgeditComponent,
    BaserouteComponent,
    LoginComponent,
    ConfirmComponent,
    ForgotComponent,
    OrgprojectaddComponent,
    OrgprojectlistComponent,
    OrgprojecteditComponent,
    PeopleComponent,
    PlanningComponent,
    TopNavComponent,
    UseraccountComponent,
    OrgaccountComponent,
    TimereportComponent,
    TimetrackingpanelComponent,
    OrglogoComponent,
    LoaderComponent,
    PortalComponent,
    ProjectslistComponent,
    CustomerControlComponent,
    CustomersComponent,
    AdhocComponent,
    OrgprojectmemberlistComponent,
    OrgprojectpendingjoinerlistComponent,
    ProjectportalComponent,
    ProjectstageComponent,
    ProjecttaskComponent,
    PersonnameComponent,
    CustomeruserlistComponent,
    CustomerprojectlistComponent,
    CustomerusercreateComponent,
    NotificationComponent,
    CustomerportalControlComponent,
    CustomernameComponent,
    ProjectoverviewComponent,
    NotificationPushComponent,
    CustomerlogoComponent,
    TasknameComponent,
    ProjecttemplatecreateComponent,
    ProjecttemplatelistComponent,
    OrgtemplatelistComponent,
    DynamicstyleComponent,
    OrgstyleComponent,
    AssigntemplaterolesComponent,
    FilelistComponent,
    CustomerpageComponent,
    CustomerusereditComponent,
    OrguseraddComponent,
    CustomercreateComponent,
    FooterMobileNavComponent,
    NotificationlistComponent,
    NotificationitemComponent,
    FooterprojectlistComponent,
    TermsofuseComponent,
    ShortdateComponent,
    ProjectnotificationComponent,
    RefreshauthComponent,
    ProjectuserviewComponent,
    ProjectnameComponent,
    OrgnotificationsettingComponent,
    BrandComponent,
    OrglogomenuComponent,
    AdminComponent,
    HighlightDirective,
    FilterPipe,
    TagfilterComponent,
    TagaddremoveComponent,
    TagadminComponent,
    UniqueloginchartComponent,
    ProjectvisibilitytoggleComponent,
    ProjectdeleteComponent,
    ProjectassignComponent,
    ProjectimeshiftComponent,
    ProjectprogressComponent,
    UniquelogincounterComponent,
    ProjectwizardComponent,
    ProjectsettingsComponent,
    DashboardComponent,
    TasktrackerchartComponent,
    DurationchartComponent,
    StatuschartComponent,
    CompactprojectlistComponent,
    DurationselectComponent,
    CustomerwelcomeComponent,
    CustomerwelcomeeditComponent,
    CustomertasklistComponent,
    SupportComponent,
    CustomerdealComponent,
    CustomerdeallistComponent,
    IntegrationsettingsComponent,
    ChartComponent,
    OrgswitcherComponent,
    UsersettingsComponent,
    RefreshsessionComponent,
    OrgsettingsComponent,
    CustomerCardComponent,
    TaskeditmodalComponent,
    CustomerportalLightComponent,
    CplDownloadComponent,
    CplSubmitComponent,
    CplEventComponent,
    CplTaskComponent,
    CplListComponent,
    ProjectautomationComponent,
    AutomationactionComponent,
    OrgautomationsComponent,
    AutomationFieldComponent,
    CalendarComponent,
    ImageuploadComponent,
    OrgnotificationlistComponent,
    NotificationAutomationComponent,
    EngagementGaugeComponent,
    ImageuploadComponent
  ],
  imports: [
    ProjectdashComponent,
    TransPipe,
    PersonimageComponent,
    ScrollingModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    NgOptimizedImage,
    TableModule,
    BrowserModule,
    AlertboxComponent,
    FileuploadComponent,
    LoadconfirmComponent,
    DragDropModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MatTooltipModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    PickerModule,
    QuillModule.forRoot(),
    ImageCropperModule,
    ImageUploadModule,
    ReactiveFormsModule,
    FormRendererComponent,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      outerStrokeColor: "#78C000",
      animationDuration: 300,
      showSubtitle: false,
      showInnerStroke: false,
    })
    //  ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),

  ],
  exports: [],
  providers: [[{ provide: HTTP_INTERCEPTORS, useClass: AddtokenInterceptor, multi: true },
  { provide: ErrorHandler, useClass: AppErrorHandler }, {
    provide: IMAGE_LOADER,
    useValue: (config: ImageLoaderConfig) => {
      return `${config.src}`;
    },
  }
  ]],
  // providers: [ { provide: ErrorHandler, useFactory: errorHandlerFactory } ],
  bootstrap: [AppComponent]
})
export class AppModule { }
